import { useMutation } from '@apollo/client';
import { PATCH_PREREQUISITE_MUTATION } from '../../mutations';

export function usePatchPrerequisiteMutation() {
    return useMutation( PATCH_PREREQUISITE_MUTATION );
}
